import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormlyModule } from '@ngx-formly/core';
import { AutoDirtyDirective } from '../../_directives/auto-dirty.directive';

export const FORM_IMPORTS = [
  AutoDirtyDirective,
  FormlyModule,
  ReactiveFormsModule,
  FormsModule,
];
